export const environment = {
  production: false,
  defaultTitle: 'UPG Dealer Portal',
  version: '2.1.7',
  apiVersion: '2.1.3',
  baseUrl: 'https://drappapi.upgapp.com/',
  //baseUrl: 'http://zinmintun.upgapp.com:8080/',
  //baseUrl: 'http://localhost:8080/',
};
